import { FC } from 'react'
import { DateTimeWindow } from '../../formComponents'
import dayjs from 'dayjs'
import { ModalSectionProps } from '../utils'

export const DateTimeWindowSection: FC<ModalSectionProps> = ({
  formData,
  form,
  setFormData,
}) => {
  const maxDate = formData?.hasPatternEndDate ? formData?.patternEnd : undefined

  const handleStartTimeChanged = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, startTime: value }))
    form?.setFieldValue('startTime', value)
  }
  const handleEndTimeChanged = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, endTime: value }))
    form?.setFieldValue('endTime', value)
  }

  return (
    <DateTimeWindow
      formData={formData}
      maxDate={maxDate}
      minDate={dayjs()}
      onEndTimeChanged={handleEndTimeChanged}
      onStartTimeChanged={handleStartTimeChanged}
    />
  )
}
